import { useMemo, useState } from "react";

// ---------------------------------------------------------------------------
// Design tokens
// ---------------------------------------------------------------------------
const TEAL = "#0D5C63";
const WHITE = "#FFFFFF";
const BORDER = "#D8DADF";
const DARK = "#1A1A2E";
const GRAY = "#6B7280";
const GRAY_MID = "#9CA3AF";
const AMBER = "#B45309";
const GREEN = "#166534";
const CARD_BG = "#EDEEF0";
const BLUE_IMPORT = "#2563EB";

// ---------------------------------------------------------------------------
// Static data — inbound product tracking (demo)
// ---------------------------------------------------------------------------
const SHIPMENTS_INBOUND = [
  { id: "PLE-72194", shipRef: "PLE117", status: "Scheduled", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "—", eta: "—", brand: "Tierra Tequila", cases: 120, contents: "Tierra Blanco, Reposado, Still Strength", customs: "Pending", notes: "Awaiting export docs from supplier" },
  { id: "PLE-71709", shipRef: "NA", status: "In Transit", type: "Domestic", origin: "Bluegrass Bottling KY", destination: "Central Wine & Spirits", etd: "03/15/26", eta: "03/20/26", brand: "Tierra Tequila", cases: 60, contents: "Tierra Agave Amburana, Tempranillo", customs: "N/A", notes: "Domestic transfer from bottling" },
  { id: "PLE-71200", shipRef: "PLE118", status: "Scheduled", type: "International Import", origin: "Santos, Brazil", destination: "Eastport Warehouses NJ", etd: "03/25/26", eta: "04/10/26", brand: "Verde Cachaca", cases: 200, contents: "Verde Prata 750ml, Oak 750ml", customs: "Pending", notes: "Container NV-2026-15 — broker notified" },
  { id: "PLE-70500", shipRef: "NA", status: "In Transit", type: "Domestic", origin: "Eastport Warehouses NJ", destination: "Nordic Storage", etd: "03/12/26", eta: "03/14/26", brand: "Fjord Aquavit", cases: 24, contents: "Fjord Swedish 750ml — aged release", customs: "N/A", notes: "LTL freight booked" },
  { id: "PLE-69800", shipRef: "PLE116", status: "Inbounded", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "02/18/26", eta: "02/25/26", brand: "Tierra Tequila", cases: 90, contents: "Tierra Blanco 750ml", customs: "Cleared", notes: "Cleared customs 02/24, received at warehouse 02/25" },
  { id: "PLE-67567", shipRef: "NA", status: "Inbounded", type: "Domestic", origin: "Bluegrass Bottling KY", destination: "Central Wine & Spirits", etd: "02/08/26", eta: "02/12/26", brand: "Tierra Tequila", cases: 45, contents: "Tierra SBS Reposado", customs: "N/A", notes: "" },
  { id: "PLE-66756", shipRef: "PLE116", status: "Inbounded", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "01/18/26", eta: "01/25/26", brand: "Tierra Tequila", cases: 80, contents: "Mixed Tierra — Blanco, Reposado, Anejo", customs: "Cleared", notes: "Duty paid $2,340" },
  { id: "PLE-65821", shipRef: "NA", status: "Inbounded", type: "Domestic", origin: "Bluegrass Bottling KY", destination: "Central Wine & Spirits", etd: "01/10/26", eta: "01/14/26", brand: "Tierra Tequila", cases: 30, contents: "Tierra Still Strength 750ml", customs: "N/A", notes: "" },
  { id: "PLE-65155", shipRef: "PLE115", status: "Inbounded", type: "International Import", origin: "Santos, Brazil", destination: "Eastport Warehouses NJ", etd: "01/05/26", eta: "01/15/26", brand: "Verde Cachaca", cases: 180, contents: "Verde Prata 750ml (120), Oak (36), Amburana (24)", customs: "Cleared", notes: "Container NV-2026-01 — duty $4,890" },
  { id: "PLE-65018", shipRef: "NA", status: "Inbounded", type: "Domestic", origin: "Eastport Warehouses NJ", destination: "Eastport Warehouses NJ", etd: "01/02/26", eta: "01/02/26", brand: "Coastal Craft Cocktails", cases: 288, contents: "Production Run #DR-0102 — G&T, Caipirinha, Zombie", customs: "N/A", notes: "Canned on-site at Eastport" },
  { id: "PLE-62491", shipRef: "NA", status: "Inbounded", type: "Domestic", origin: "Bluegrass Bottling KY", destination: "Central Wine & Spirits", etd: "12/15/25", eta: "12/19/25", brand: "Tierra Tequila", cases: 55, contents: "Tierra Blanco, Reposado", customs: "N/A", notes: "" },
  { id: "PLE-61994", shipRef: "—", status: "Inbounded", type: "Domestic", origin: "Central Wine & Spirits", destination: "Summit Products", etd: "12/01/25", eta: "12/05/25", brand: "Velvet Cacao", cases: 72, contents: "Velvet Cacao White Choc, Strawberry, Regular", customs: "N/A", notes: "Production run — bottled at Parallel" },
  { id: "PLE-59474", shipRef: "PLE114", status: "Inbounded", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "11/15/25", eta: "11/25/25", brand: "Tierra Tequila", cases: 100, contents: "Tierra Blanco 750ml, SBS Reposado", customs: "Cleared", notes: "Duty paid $3,100" },
  { id: "PLE-57973", shipRef: "PLE113", status: "Inbounded", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "—", eta: "—", brand: "Tierra Tequila", cases: 75, contents: "Tierra Anejo, Extra Anejo", customs: "Cleared", notes: "High-value shipment" },
  { id: "PLE-55097", shipRef: "PLE112", status: "Inbounded", type: "International Import", origin: "Destilados del Sur", destination: "Bluegrass Bottling...", etd: "09/30/24", eta: "10/18/24", brand: "Tierra Tequila", cases: 110, contents: "Tierra Blanco, Reposado, Still Strength", customs: "Cleared", notes: "" }
];

const TYPE_FILTERS = ["All", "International Import", "Domestic"];

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
function getStatusStyle(status) {
  const map = {
    Scheduled: { bg: "rgba(180,83,9,0.08)", text: AMBER, border: "rgba(180,83,9,0.2)" },
    "In Transit": { bg: "rgba(37,99,235,0.08)", text: BLUE_IMPORT, border: "rgba(37,99,235,0.2)" },
    Inbounded: { bg: "rgba(22,101,52,0.08)", text: GREEN, border: "rgba(22,101,52,0.2)" }
  };
  return map[status] || { bg: CARD_BG, text: GRAY, border: BORDER };
}

function getCustomsStyle(customs) {
  if (customs === "Cleared") return { bg: "rgba(22,101,52,0.08)", text: GREEN };
  if (customs === "Pending") return { bg: "rgba(180,83,9,0.08)", text: AMBER };
  return { bg: CARD_BG, text: GRAY };
}

function countByStatus(rows) {
  const counts = {};
  rows.forEach((r) => { counts[r.status] = (counts[r.status] || 0) + 1; });
  return counts;
}

function sumCases(rows, predicate) {
  return rows.filter(predicate).reduce((s, r) => s + r.cases, 0);
}

// ---------------------------------------------------------------------------
// UI primitives
// ---------------------------------------------------------------------------
function Alert({ type, children }) {
  const config = {
    info: { bg: "#EFF6FF", border: "#BFDBFE", accent: BLUE_IMPORT, icon: "ℹ" },
    warning: { bg: "#FEF3C7", border: "#FCD34D", accent: AMBER, icon: "⚠" }
  }[type];

  return (
    <div
      style={{
        background: config.bg,
        border: `1px solid ${config.border}`,
        borderLeft: `4px solid ${config.accent}`,
        borderRadius: 8,
        padding: "9px 14px",
        marginBottom: 12,
        display: "flex",
        gap: 8,
        alignItems: "flex-start",
        fontSize: 12
      }}
    >
      <span style={{ fontSize: 13, flexShrink: 0 }}>{config.icon}</span>
      <div style={{ color: DARK, lineHeight: 1.5 }}>{children}</div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Page
// ---------------------------------------------------------------------------
export default function ShipmentsPage() {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");

  const statusCounts = useMemo(() => countByStatus(SHIPMENTS_INBOUND), []);
  const totalCasesInbound = useMemo(() => SHIPMENTS_INBOUND.reduce((s, r) => s + r.cases, 0), []);
  const scheduledCases = useMemo(() => sumCases(SHIPMENTS_INBOUND, (r) => r.status === "Scheduled"), []);
  const transitCases = useMemo(() => sumCases(SHIPMENTS_INBOUND, (r) => r.status === "In Transit"), []);
  const inboundedCases = useMemo(() => sumCases(SHIPMENTS_INBOUND, (r) => r.status === "Inbounded"), []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return SHIPMENTS_INBOUND
      .filter((r) => statusFilter === "All" || r.status === statusFilter)
      .filter((r) => typeFilter === "All" || r.type === typeFilter)
      .filter(
        (r) =>
          !q ||
          r.id.toLowerCase().includes(q) ||
          r.brand.toLowerCase().includes(q) ||
          r.contents.toLowerCase().includes(q) ||
          r.origin.toLowerCase().includes(q)
      );
  }, [search, statusFilter, typeFilter]);

  const funnelTiles = [
    { label: "Total Shipments", count: SHIPMENTS_INBOUND.length, cases: totalCasesInbound, icon: "📋", color: TEAL, key: "All" },
    { label: "Scheduled", count: statusCounts.Scheduled || 0, cases: scheduledCases, icon: "📅", color: AMBER, key: "Scheduled" },
    { label: "In Transit", count: statusCounts["In Transit"] || 0, cases: transitCases, icon: "🚢", color: BLUE_IMPORT, key: "In Transit" },
    { label: "Inbounded", count: statusCounts.Inbounded || 0, cases: inboundedCases, icon: "✅", color: GREEN, key: "Inbounded" }
  ];

  const scheduledN = statusCounts.Scheduled || 0;
  const transitN = statusCounts["In Transit"] || 0;

  return (
    <div style={{ padding: "16px 18px", background: "#F4F5F7", minHeight: "100vh" }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: DARK, marginBottom: 12 }}>Shipments</div>

      {scheduledN > 0 && (
        <Alert type="info">
          <strong>
            {scheduledN} shipment{scheduledN > 1 ? "s" : ""} scheduled
          </strong>
          {" — "}
          {scheduledCases} cases pending departure. International imports require customs clearance before receiving.
        </Alert>
      )}
      {transitN > 0 && (
        <Alert type="warning">
          <strong>
            {transitN} shipment{transitN > 1 ? "s" : ""} in transit
          </strong>
          {" — "}
          {transitCases} cases en route. Track ETAs for warehouse receiving preparation.
        </Alert>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 10, marginBottom: 16 }}>
        {funnelTiles.map((tile) => {
          const active = statusFilter === tile.key;
          return (
            <button
              key={tile.key}
              type="button"
              onClick={() => setStatusFilter(tile.key)}
              style={{
                background: active ? tile.color : WHITE,
                border: `2px solid ${active ? tile.color : BORDER}`,
                borderRadius: 10,
                padding: "14px 16px",
                cursor: "pointer",
                textAlign: "center",
                transition: "all 0.15s",
                font: "inherit"
              }}
            >
              <div style={{ fontSize: 22 }}>{tile.icon}</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: active ? WHITE : tile.color, marginTop: 4 }}>{tile.count}</div>
              <div style={{ fontSize: 10, fontWeight: 600, color: active ? "rgba(255,255,255,0.8)" : GRAY, textTransform: "uppercase", letterSpacing: "0.04em" }}>{tile.label}</div>
              <div style={{ fontSize: 10, color: active ? "rgba(255,255,255,0.6)" : GRAY_MID, marginTop: 2 }}>{tile.cases} cases</div>
            </button>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
        <div style={{ position: "relative", flex: "0 0 280px" }}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search shipments..."
            style={{ width: "100%", padding: "7px 12px 7px 32px", border: `1px solid ${BORDER}`, borderRadius: 6, fontSize: 12, color: DARK, background: WHITE, outline: "none" }}
          />
          <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14, color: GRAY_MID }}>🔍</span>
        </div>
        <div style={{ display: "flex", gap: 4 }}>
          {TYPE_FILTERS.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTypeFilter(t)}
              style={{
                padding: "5px 10px",
                border: `1px solid ${typeFilter === t ? TEAL : BORDER}`,
                borderRadius: 5,
                background: typeFilter === t ? TEAL : WHITE,
                color: typeFilter === t ? WHITE : DARK,
                fontSize: 11,
                fontWeight: typeFilter === t ? 700 : 400,
                cursor: "pointer",
                whiteSpace: "nowrap",
                font: "inherit"
              }}
            >
              {t === "All" ? "All Types" : t}
            </button>
          ))}
        </div>
        <div style={{ marginLeft: "auto", fontSize: 11, color: GRAY }}>
          <strong style={{ color: DARK }}>{filtered.length}</strong> shipments ·{" "}
          <strong style={{ color: DARK }}>{filtered.reduce((s, r) => s + r.cases, 0)}</strong> cases
        </div>
      </div>

      <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 10, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["Shipment ID", "Ref", "Status", "Type", "Brand", "Cases", "Origin", "Destination", "ETD", "ETA", "Customs", "Contents"].map((h) => (
                <th
                  key={h}
                  style={{
                    background: TEAL,
                    color: WHITE,
                    padding: "8px 10px",
                    textAlign: h === "Cases" ? "right" : "left",
                    fontSize: 10.5,
                    fontWeight: 600,
                    whiteSpace: "nowrap"
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => {
              const sc = getStatusStyle(r.status);
              const cc = getCustomsStyle(r.customs);
              const rowBg =
                r.status === "Scheduled"
                  ? "rgba(180,83,9,0.03)"
                  : r.status === "In Transit"
                    ? "rgba(37,99,235,0.03)"
                    : i % 2 === 0
                      ? WHITE
                      : CARD_BG;

              return (
                <tr key={`${r.id}-${i}`} style={{ background: rowBg, borderBottom: `1px solid ${BORDER}` }}>
                  <td style={{ padding: "8px 10px", fontWeight: 700, color: TEAL, fontFamily: "monospace", fontSize: 11 }}>{r.id}</td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 11 }}>{r.shipRef}</td>
                  <td style={{ padding: "8px 10px" }}>
                    <span style={{ background: sc.bg, color: sc.text, border: `1px solid ${sc.border}`, borderRadius: 4, padding: "3px 8px", fontSize: 10, fontWeight: 700, whiteSpace: "nowrap" }}>{r.status}</span>
                  </td>
                  <td style={{ padding: "8px 10px", fontSize: 11, color: r.type === "International Import" ? BLUE_IMPORT : GRAY }}>{r.type}</td>
                  <td style={{ padding: "8px 10px", fontWeight: 500, color: DARK, fontSize: 11 }}>{r.brand.split(" ")[0]}</td>
                  <td style={{ padding: "8px 10px", textAlign: "right", fontWeight: 700 }}>{r.cases}</td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 10, maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.origin}</td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 10, maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.destination}</td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 11, whiteSpace: "nowrap" }}>{r.etd}</td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 11, whiteSpace: "nowrap" }}>{r.eta}</td>
                  <td style={{ padding: "8px 10px" }}>
                    <span style={{ background: cc.bg, color: cc.text, borderRadius: 4, padding: "2px 6px", fontSize: 10, fontWeight: 600 }}>{r.customs}</span>
                  </td>
                  <td style={{ padding: "8px 10px", color: GRAY, fontSize: 10, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.contents}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
